import React, {Component} from 'react';
import './Account.css';
import FormCommunicate from "../common/FormCommunicate";
import {post} from "../common/Http";

class BetaChange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false,
            communicate: '',
            postpone: this.props.account['beta_postpone'] || 0
        };
    }

    save(event) {
        event.preventDefault();
        this.setState({
            loading: true,
            error: false,
            communicate: ''
        });
        fetch(`${process.env.REACT_APP_API_URL}/account/beta`, post({
            beta_postpone: this.state.postpone
        })).then(response => {
            this.setState({
                loading: false
            });
            if (response.ok) {
                this.setState({
                    communicate: 'Zmiany zostały zapisane',
                    error: false
                });
            } else {
                throw response.status
            }
        }).catch(statusCode => {
            let communicate;
            switch (statusCode) {
                case 400:
                    communicate = 'Nieprawidłowe dane, zmiany nie zostały zapisane.';
                    break;
                default:
                    communicate = 'Wystąpił błąd, zmiany nie zostały zapisane.';
            }
            this.setState({
                loading: false,
                error: true,
                communicate: communicate
            })
        });
    }

    render() {
        return (
            <form className="content-form">
                <FormCommunicate communicate={this.state.communicate}
                                 error={this.state.error}/>
                <div className="form-row">
                    <label htmlFor="postpone">Odroczenie certyfikatów</label>
                    <select id="postpone"
                            value={this.state.postpone}
                            onChange={event => this.setState({postpone: event.target.value})}>
                        <option value={1}>Aktywne</option>
                        <option value={0}>Nieaktywne</option>
                    </select>
                </div>
                <div className="form-row">
                    <label/>
                    {this.state.loading ?
                        <div className="spinner"/> :
                        <button className="small primary"
                                onClick={e => this.save(e)}>Aktualizuj ustawienia</button>
                    }
                </div>
            </form>
        );
    }
}

export default BetaChange;